export const userRoles = {
  REGULAR: 'REGULAR',
  CONTENT_ADMIN: 'CONTENT_ADMIN',
  SUPER_ADMIN: 'SUPER_ADMIN',
};

export function canAccessPrivateMenuItems(role: string) {
  return role === userRoles.SUPER_ADMIN;
}

export function canAccessCompanySelection(role: string) {
  return role === userRoles.SUPER_ADMIN;
}
